import { useEffect, useState } from 'react'

/**
 * Checks if the supplied DOM element is scrolled or not
 */
export const useIsScrolled = (el: HTMLElement | undefined | null) => {
  const [ready, setReady] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  useEffect(() => {
    if (!el) return

    const onScroll = () => {
      setIsScrolled(el.scrollTop > 0)
    }

    el.addEventListener('scroll', onScroll)
    return () => el.removeEventListener('scroll', onScroll)
  }, [el, ready])

  // Check again after initial render in case the el is being bound to a ref
  useEffect(() => {
    setReady(true)
  }, [])

  return isScrolled
}
